import React, { useState } from "react";
import PropTypes from "prop-types";

import PersonPreview from "components/PersonPreview";
import classNames from "classnames";
import { noop } from "lodash-es";
import Button from "ui/Button";
import AnimatedModal from "components/Modal/AnimatedModal";
import BlackListAlert from "../../../../entities/BlacklistTooltip/index";

//основной список игроков game
const PlayersListItem = ({
    family_name,
    name,
    avatar,
    id,
    is_came,
    is_online_pay,
    isOrganizer,
    onPlayerClick = noop,
    isRegular,
    blacklisted,
    isInvate,
    isFreePlaceInMainList,
    ...props
}) => {
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(null);

    const onRemove = async (id) => {
        setDisabled(true);
        try {
            const userName = is_online_pay ? `${name} ${family_name}` : null;
            await props.onRemove(id, userName);
        } finally {
            setDisabled(false);
        }
    };

    const transferPlayerToMainList = async (userId) => {
        try {
            await props.transferPlayerToMainList(userId);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div
            key={`Players-detailing-item-${id}`}
            className={classNames("players-list__item", {
                "players-list__item--skipped":
                    isRegular && !isInvate ? false : !is_came,
            })}
        >
            <PersonPreview
                id={id}
                family_name={family_name}
                name={name}
                avatar={avatar}
                mods={[`person--row`]}
                onClick={onPlayerClick}
                payment={is_online_pay && isOrganizer && "Оплачено онлайн"}
            />

            {isOrganizer && (
                <>
                    {!isRegular && !!blacklisted && blacklisted?.length > 0 && (
                        <BlackListAlert blacklisted={blacklisted} id={id} />
                    )}
                    {isFreePlaceInMainList ? (
                        <div className="players-list__right">
                            <Button
                                text
                                size="small"
                                mixes={[`w-100`]}
                                disabled={disabled}
                                onClick={() => transferPlayerToMainList(id)}
                            >
                                <span className="btn__span">
                                    В основной состав
                                </span>
                            </Button>
                        </div>
                    ) : (
                        <div className="players-list__right">
                            <Button
                                text
                                size="small"
                                mixes={[`w-100`]}
                                disabled={disabled}
                                onClick={() => onRemove(id)}
                            >
                                <span className="btn__span">Отписать</span>
                            </Button>
                        </div>
                    )}
                </>
            )}

            {error && (
                <AnimatedModal
                    visible={true}
                    title={`Не удалось`}
                    onClose={() => setError(null)}
                    closeOnOverlay={true}
                    modificators={[`small-col`]}
                >
                    {(close) => (
                        <>
                            <p className="text-center c-gs-medium-em mb-32">
                                {error}
                            </p>
                            <div className="btn-group-row">
                                <Button
                                    primary
                                    size="medium"
                                    mixes={[`m-x-auto`]}
                                    onClick={close}
                                >
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}
        </div>
    );
};

PlayersListItem.propTypes = {
    isOrganizer: PropTypes.bool,
    onRemove: PropTypes.func.isRequired,
    id: PropTypes.number,
    family_name: PropTypes.string,
    name: PropTypes.string,
    avatar: PropTypes.shape({ url: PropTypes.string }),
    is_came: PropTypes.bool,
    is_online_pay: PropTypes.bool,
    onPlayerClick: PropTypes.func,
    blacklisted: PropTypes.arrayOf(
        PropTypes.shape({
            creator: PropTypes.object,
            reason: PropTypes.string,
            created_at: PropTypes.string,
        })
    ),
    isRegular: PropTypes.bool,
    isInvate: PropTypes.bool,
    isFreePlaceInMainList: PropTypes.bool,
    transferPlayerToMainList: PropTypes.func,
};

export default PlayersListItem;
